module.exports = Em.View.extend({
    templateName: 'daybook/balance-accounts',

    classNames: ['daybook-balance-accounts']
})
